// @core/api/endpoints/notifications/create_channel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChannelResponse,
  CreateChannelRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Create notification channel
 * Creates a new notification channel for message delivery. Channels can be configured for email, SMS, push notifications, or other supported providers.
 */
export async function CreateChannel(
  data: CreateChannelRequest,
  options?: RequestOptions
): Promise<ChannelResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/channels`;
  const requestOptions = options;
  return client.post<ChannelResponse>(requestPath, data, requestOptions);
}
